import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import tagBlogs from '../queries/tagBlogs';
import BlogCardSmall from './BlogCardSmall';

interface CollectionProps {
  tags: string[];
  count?: number;
  size?: string;
}

export default function BlogCollectionSmall(props: CollectionProps) {
  const blogs = tagBlogs(props.tags, 0, props.count);

  return (
    <Grid
      container
      columns={{ sm: 2, md: 2, lg: 1 }}
      justifyContent='center'
      display='flex'
    >
      {blogs.map((blog: any) => (
        <Grid sm={1} md={1} lg={1} key={blog.handle} my={1}>
          <BlogCardSmall key={blog.handle} blog={blog} />
        </Grid>
      ))}
    </Grid>
  );
}
